import React, { useEffect, useState } from 'react'
import printJS from 'print-js'
import {
  FileText,
  Building,
  CreditCard,
  Calendar,
  CheckCircle,
  ChevronLeft,
  ChevronRight
} from 'lucide-react'

const CompletedInstallmentsPrint = ({
  installments,
  companyInfo,
  totalPlotAmount,
  totalPaidAmount,
  initialPayment // Added missing prop
}) => {
  const [pendingAndOverdue, setPendingAndOverdue] = useState([])
  const [completed, setCompleted] = useState([])
  const [activeTab, setActiveTab] = useState('completed')

  console.log('companyInfo', companyInfo)
  useEffect(() => {
    if (installments && Array.isArray(installments)) {
      setPendingAndOverdue(
        installments.filter(inst => ['Pending', 'Overdue', 'Partially Paid'].includes(inst?.status))
      )
      setCompleted(installments.filter(inst => inst?.status === 'Completed'))
    }
  }, [installments])
  console.log('Total Installment:', installments)

  const formatCNIC = cnic => {
    if (!cnic) return ''
    return cnic.replace(/^(\d{5})(\d{7})(\d{1})$/, '$1-$2-$3')
  }

  // Extract society info safely
  const society = companyInfo?.soc || companyInfo?.society || {
    name: 'Society',
    location: 'N/A',
    society_image: null
  }
  const societyImage = society?.society_image || 'default-image.jpg'

  const handlePrint = () => {
    const safeTotalPlotAmount = totalPlotAmount || 0;
    const printContent = `
    <div style="font-family: 'Segoe UI', 'Inter', system-ui, sans-serif; margin: 0; padding: 12px; max-width: 1000px; margin: 0 auto; background: white;">
      <!-- Modern Header with Company Info -->
      <div style="background: linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #1e40af 100%); color: white; padding: 12px; border-radius: 12px; margin-bottom: 12px; box-shadow: 0 4px 16px rgba(59, 130, 246, 0.25); position: relative; overflow: hidden;">
        <div style="position: absolute; top: 0; right: 0; width: 80px; height: 80px; background: rgba(255,255,255,0.1); border-radius: 50%; transform: translate(30px, -30px);"></div>
        <div style="display: flex; justify-content: space-between; align-items: center; position: relative; z-index: 1;">
          <div style="display: flex; align-items: center; gap: 12px;">
            <img src="${societyImage}" alt="Society Logo" style="width: 45px; height: 45px; border-radius: 8px; object-fit: cover; border: 2px solid rgba(255,255,255,0.2); box-shadow: 0 2px 8px rgba(0,0,0,0.15);" />
            <div>
              <h1 style="margin: 0; font-size: 18px; font-weight: 700; letter-spacing: -0.3px;">${society?.name || 'Property Management'
      }</h1>
              <p style="margin: 2px 0 0; opacity: 0.9; font-size: 11px; font-weight: 500;">${society?.location || ''
      }</p>
            </div>
          </div>
          <div style="text-align: right;">
            <div style="background: rgba(255,255,255,0.15); padding: 8px 12px; border-radius: 8px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.2);">
              <p style="margin: 0; font-size: 9px; opacity: 0.9; font-weight: 500; text-transform: uppercase; letter-spacing: 0.3px;">Total Plot Value</p>
              <p style="margin: 2px 0 0; font-size: 14px; font-weight: 700;">PKR ${(safeTotalPlotAmount || 0).toLocaleString()}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Modern Info Cards Grid -->
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; margin-bottom: 12px;">
        <!-- Customer Details Card -->
        <div style="background: white; padding: 12px; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); border: 1px solid #e5e7eb;">
          <h3 style="margin: 0 0 8px; font-size: 12px; color: #1e40af; display: flex; align-items: center; gap: 6px; font-weight: 600;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            Customer Information
          </h3>
          ${renderDetailCard(installments[0]?.customer_id)}

        </div>

        <!-- Property Details Card -->
        <div style="background: white; padding: 12px; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); border: 1px solid #e5e7eb;">
          <h3 style="margin: 0 0 8px; font-size: 12px; color: #1e40af; display: flex; align-items: center; gap: 6px; font-weight: 600;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            Property Details
          </h3>
          ${renderPropertyDetails(companyInfo)}
        </div>
      </div>

      <!-- Completed Installments Section -->
      <div style="margin-bottom: 12px;">
        <h3 style="margin: 0 0 8px; font-size: 14px; color: #1e40af; display: flex; align-items: center; gap: 6px; font-weight: 600;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          Completed Installments
        </h3>
        <div style="background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08); border: 1px solid #e5e7eb;">
          <table style="width: 100%; border-collapse: separate; border-spacing: 0; font-size: 10px;">
            <thead>
              <tr style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);">
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #e5e7eb; color: #1e40af; font-weight: 600; font-size: 10px;">Installment No.</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #e5e7eb; color: #1e40af; font-weight: 600; font-size: 10px;">Amount Paid</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #e5e7eb; color: #1e40af; font-weight: 600; font-size: 10px;">Payment Date</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #e5e7eb; color: #1e40af; font-weight: 600; font-size: 10px;">Status</th>
              </tr>
            </thead>
            <tbody>
              ${completed
        .map(
          (inst, index) => `
                <tr style="background: ${index % 2 === 0 ? '#fff' : '#f8fafc'
            }; transition: background-color 0.2s ease;">
                  <td style="padding: 8px; border-bottom: 1px solid #e5e7eb; text-align: center; font-weight: 500;">${inst.installment_number
            }</td>
                  <td style="padding: 8px; border-bottom: 1px solid #e5e7eb; font-weight: 600; color: #166534;">PKR ${(inst.paid_amount || 0).toLocaleString()}</td>
                  <td style="padding: 8px; border-bottom: 1px solid #e5e7eb; font-weight: 500;">${new Date(
              inst.payment_date
            ).toLocaleDateString('en-GB')}</td>
                  <td style="padding: 8px; border-bottom: 1px solid #e5e7eb;">
                    <span style="background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%); color: #166534; padding: 3px 8px; border-radius: 12px; font-size: 8px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px; border: 1px solid #22c55e;">
                      Completed
                    </span>
                  </td>
                </tr>
              `
        )
        .join('')}
            </tbody>
          </table>
        </div>
      </div>

      <!-- Remaining Installments Section -->
      <div style="margin-bottom: 12px;">
        <h3 style="margin: 0 0 8px; font-size: 14px; color: #1e40af; display: flex; align-items: center; gap: 6px; font-weight: 600;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          Remaining Installments
        </h3>
        <div style="background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08); border: 1px solid #e5e7eb;">
          <table style="width: 100%; border-collapse: separate; border-spacing: 0; font-size: 10px;">
            <thead>
              <tr style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);">
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #e5e7eb; color: #1e40af; font-weight: 600; font-size: 10px;">Installment No.</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #e5e7eb; color: #1e40af; font-weight: 600; font-size: 10px;">Amount Due</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #e5e7eb; color: #1e40af; font-weight: 600; font-size: 10px;">Due Date</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #e5e7eb; color: #1e40af; font-weight: 600; font-size: 10px;">Status</th>
              </tr>
            </thead>
            <tbody>
              ${pendingAndOverdue
        .map(
          (inst, index) => `
                <tr style="background: ${index % 2 === 0 ? '#fff' : '#f8fafc'
            }; transition: background-color 0.2s ease;">
                  <td style="padding: 8px; border-bottom: 1px solid #e5e7eb; text-align: center; font-weight: 500;">${inst.installment_number
            }</td>
                  <td style="padding: 8px; border-bottom: 1px solid #e5e7eb; font-weight: 600; color: #dc2626;">PKR ${(inst.remaining_amount || 0).toLocaleString()}</td>
                  <td style="padding: 8px; border-bottom: 1px solid #e5e7eb; font-weight: 500;">${new Date(
              inst.due_date
            ).toLocaleDateString('en-GB')}</td>
                  <td style="padding: 8px; border-bottom: 1px solid #e5e7eb;">
                    <span style="background: ${inst.status === 'Pending'
              ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
              : 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
            };
                                color: ${inst.status === 'Pending'
              ? '#92400e'
              : '#991b1b'
            };
                                padding: 3px 8px;
                                border-radius: 12px;
                                font-size: 8px;
                                font-weight: 600;
                                text-transform: uppercase;
                                letter-spacing: 0.3px;
                                border: 1px solid ${inst.status === 'Pending' ? '#f59e0b' : '#ef4444'
            };">
                      ${inst.status}
                    </span>
                  </td>
                </tr>
              `
        )
        .join('')}
            </tbody>
          </table>
        </div>
      </div>

      <!-- Summary Cards -->
      <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 20px;">
        ${renderSummaryCard(
          'Total Installments',
          installments.length,
          '#3b82f6',
          '#eff6ff'
        )}
        ${renderSummaryCard(
          'Completed',
          completed.length,
          '#10b981',
          '#f0fdf4'
        )}
        ${renderSummaryCard(
          'Remaining',
          pendingAndOverdue.length,
          '#f59e0b',
          '#fef3c7'
        )}
      </div>

      <!-- Footer with Signatures -->
      <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 20px; padding-top: 15px; border-top: 2px solid #e5e7eb;">
        <div style="text-align: center; flex: 1;">
          <div style="width: 80px; height: 80px; margin: 0 auto; border: 2px solid #3b82f6; border-radius: 50%; display: flex; justify-content: center; align-items: center; opacity: 0.7; background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);">
            <span style="color: #1e40af; font-size: 9px; font-weight: 600; text-align: center; line-height: 1.2;">OFFICIAL<br/>STAMP</span>
          </div>
        </div>
        <div style="text-align: center; flex: 1;">
          <div style="width: 150px; margin: 0 auto; border-top: 2px solid #3b82f6; padding-top: 8px; position: relative;">
            <div style="position: absolute; bottom: -2px; left: 50%; transform: translateX(-50%); width: 30px; height: 2px; background: #3b82f6; border-radius: 1px;"></div>
            <p style="margin: 0; color: #1e40af; font-size: 10px; font-weight: 600;">Authorized Signature</p>
            <p style="margin: 2px 0 0; color: #64748b; font-size: 9px;">Date: ${new Date().toLocaleDateString('en-GB')}</p>
          </div>
        </div>
        <div style="text-align: center; flex: 1;">
          <div style="width: 150px; margin: 0 auto; border-top: 2px solid #3b82f6; padding-top: 8px; position: relative;">
            <div style="position: absolute; bottom: -2px; left: 50%; transform: translateX(-50%); width: 30px; height: 2px; background: #3b82f6; border-radius: 1px;"></div>
            <p style="margin: 0; color: #1e40af; font-size: 10px; font-weight: 600;">Customer Signature</p>
            <p style="margin: 2px 0 0; color: #64748b; font-size: 9px;">Date: ${new Date().toLocaleDateString('en-GB')}</p>
          </div>
        </div>
      </div>
    </div>
  `

    // Create a new window for printing
    const printWindow = window.open('', '_blank', 'width=800,height=600')

    const completePrintContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Completed Installments Summary</title>
        <style>
          @media print {
            @page { 
              size: A4 portrait; 
              margin: 8mm; 
            }
            body { margin: 0; }
            .no-print { display: none !important; }
          }
          body { 
            font-family: 'Segoe UI', 'Inter', 'Arial', sans-serif; 
            margin: 0; 
            padding: 12px; 
            background: white;
            font-size: 11px;
            line-height: 1.4;
            color: #1f2937;
          }
          .print-btn { 
            background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%); 
            color: white; 
            padding: 8px 16px; 
            border: none; 
            border-radius: 6px; 
            cursor: pointer; 
            font-size: 12px; 
            font-weight: 600;
            margin: 12px 0; 
            box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
            transition: all 0.3s ease;
          }
          .print-btn:hover { 
            background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%); 
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          }
          h1 { font-size: 18px !important; font-weight: 700 !important; }
          h3 { font-size: 14px !important; margin-bottom: 8px !important; font-weight: 600 !important; }
          p { margin: 2px 0 !important; }
          table { font-size: 10px; }
          th, td { padding: 8px !important; }
        </style>
      </head>
      <body>
        ${printContent}
        
        <div style="text-align: center; margin-top: 20px;">
          <button onclick="window.print()" class="print-btn no-print">
            Print Summary
          </button>
        </div>
      </body>
      </html>
    `

    // Write content to the new window and print
    printWindow.document.write(completePrintContent)
    printWindow.document.close()

    // Wait for content to load then print
    printWindow.onload = function () {
      printWindow.print()
      printWindow.close()
    }

    // Helper functions remain the same but with enhanced styling
    function renderDetailCard(customerDetails) {
      console.log('Customer Details for Print:', customerDetails)
      return `
      <div style="display: grid; gap: 10px;">
        <div style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); padding: 10px; border-radius: 8px; border: 1px solid #e2e8f0;">
          <p style="margin: 0; color: #64748b; font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.3px;">Full Name</p>
          <p style="margin: 2px 0 0; font-weight: 600; color: #1e293b; font-size: 10px;">${customerDetails?.name || 'N/A'}</p>
        </div>
        <div style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); padding: 10px; border-radius: 8px; border: 1px solid #e2e8f0;">
          <p style="margin: 0; color: #64748b; font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.3px;">Contact Number</p>
          <p style="margin: 2px 0 0; font-weight: 600; color: #1e293b; font-size: 10px;">${customerDetails?.contactInfo?.phone || 'N/A'}</p>
        </div>
        <div style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); padding: 10px; border-radius: 8px; border: 1px solid #e2e8f0;">
          <p style="margin: 0; color: #64748b; font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.3px;">CNIC Number</p>
          <p style="margin: 2px 0 0; font-weight: 600; color: #1e293b; font-size: 10px;">${formatCNIC(customerDetails?.contactInfo?.cnic) || 'N/A'}</p>
        </div>
      </div>
    `
    }

    function renderPropertyDetails(companyInfo) {
      return `
      <div style="display: grid; gap: 10px;">
        <div style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); padding: 10px; border-radius: 8px; border: 1px solid #e2e8f0;">
          <p style="margin: 0; color: #64748b; font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.3px;">Property Information</p>
          <p style="margin: 2px 0 0; font-weight: 600; color: #1e293b; font-size: 10px;">${society?.name || 'Society'}</p>
          <p style="margin: 2px 0 0; font-weight: 500; color: #1e293b; font-size: 10px;">${companyInfo?.plot_type || 'N/A'
        } - Plot #${companyInfo?.plot_number || 'N/A'}</p>
          <p style="margin: 2px 0 0; color: #64748b; font-size: 9px;">Block: ${companyInfo?.block || 'N/A'}</p>
          <p style="margin: 2px 0 0; color: #64748b; font-size: 9px;">Size: ${companyInfo?.size || 'N/A'
        } Marla</p>
        </div>

        <div style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); padding: 10px; border-radius: 8px; border: 1px solid #e2e8f0;">
          <p style="margin: 0; color: #64748b; font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.3px;">Payment Schedule</p>
          <div style="margin-top: 8px; display: grid; gap: 6px;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span style="color: #64748b; font-size: 9px;">Total Installments:</span>
              <span style="font-weight: 600; color: #1e293b; font-size: 10px;">${installments?.length || 0
        }</span>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span style="color: #64748b; font-size: 9px;">Completed:</span>
              <span style="font-weight: 600; color: #10b981; font-size: 10px;">${completed?.length || 0
        }</span>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span style="color: #64748b; font-size: 9px;">Remaining:</span>
              <span style="font-weight: 600; color: #f59e0b; font-size: 10px;">${pendingAndOverdue?.length || 0
        }</span>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 4px; padding-top: 4px; border-top: 1px dashed #e2e8f0;">
              <span style="color: #1e40af; font-size: 9px; font-weight: 600;">Initial Payment:</span>
              <span style="font-weight: 700; color: #1e40af; font-size: 10px;">PKR ${(initialPayment || 0).toLocaleString()}</span>
            </div>
          </div>
        </div>

        <div style="background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%); padding: 12px; border-radius: 8px; border: 2px solid #10b981;">
          <p style="margin: 0; color: #047857; font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.3px;">Total Amount</p>
          <p style="margin: 2px 0 0; font-weight: 700; font-size: 16px; color: #065f46;">
            PKR ${(totalPlotAmount || 0).toLocaleString()}
          </p>
          <p style="margin: 2px 0 0; color: #059669; font-size: 8px; font-weight: 500;">
            ${completed?.length || 0} of ${installments?.length || 0} installments paid
          </p>
        </div>
      </div>
    `
    }


    function renderSummaryCard(
      label,
      value,
      accentColor = '#3b82f6',
      bgColor = '#eff6ff'
    ) {
      const formattedValue =
        typeof value === 'number' ? value.toLocaleString() : value

      return `
      <div style="background: ${bgColor}; padding: 16px; border-radius: 12px; text-align: center; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); border: 2px solid ${accentColor}30; transition: all 0.3s ease;">
        <p style="margin: 0; color: ${accentColor}; font-size: 10px; text-transform: uppercase; letter-spacing: 0.3px; font-weight: 600;">${label}</p>
        <p style="margin: 6px 0 0; font-size: 20px; font-weight: 700; color: ${accentColor};">${formattedValue}</p>
      </div>
    `
    }
  }

  const installmentsPerPage = 5
  const [currentPage, setCurrentPage] = useState(1)

  const getCurrentInstallments = () => {
    const currentArray =
      activeTab === 'completed' ? completed : pendingAndOverdue
    const indexOfLast = currentPage * installmentsPerPage
    const indexOfFirst = indexOfLast - installmentsPerPage
    return currentArray.slice(indexOfFirst, indexOfLast)
  }

  const totalPages = Math.ceil(
    (activeTab === 'completed' ? completed.length : pendingAndOverdue.length) /
    installmentsPerPage
  )

  return (
    <div className='flex flex-col h-full bg-slate-50 overflow-hidden'>
      {/* Fixed Header Section */}
      <div className='flex-none p-4 pb-0'>
        <div className='bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 p-6 rounded-xl shadow-lg'>
          <div className='flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0'>
            <div className='flex items-center space-x-4'>
              <div className='p-2.5 bg-white/10 rounded-xl'>
                <CheckCircle className='w-6 h-6 text-white' strokeWidth={1.5} />
              </div>
              <div>
                <h1 className='text-2xl font-bold text-white tracking-tight'>
                  Installments Dashboard
                </h1>
                <p className='text-blue-100 text-sm'>
                  Track and manage your payment progress
                </p>
              </div>
            </div>
            <div className='bg-white/10 rounded-xl px-4 py-2 text-right'>
              <p className='text-blue-100 text-[10px] uppercase tracking-wider font-semibold'>Total Plot Value</p>
              <p className='text-xl font-bold text-white uppercase'>
                PKR {(totalPlotAmount || 0).toLocaleString()}
              </p>
            </div>
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-4 py-4'>
          <div className='bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4'>
            <Calendar
              className='w-5 h-5 text-blue-600 mb-4'
              strokeWidth={1.5}
            />
            <p className='text-blue-600 font-medium'>Total Installments</p>
            <p className='text-lg font-bold text-blue-800 mt-2'>
              {installments?.length || 0}
            </p>
          </div>
          <div className='bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-4'>
            <CreditCard
              className='w-5 h-5 text-green-600 mb-4'
              strokeWidth={1.5}
            />
            <p className='text-green-600 font-medium'>Amount Paid</p>
            <p className='text-lg font-bold text-green-800 mt-2'>
              PKR {(totalPaidAmount || 0).toLocaleString()}
            </p>
          </div>
          <div className='bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-4'>
            <Building
              className='w-5 h-5 text-purple-600 mb-4'
              strokeWidth={1.5}
            />
            <p className='text-purple-600 font-medium'>Per Installment</p>
            <p className='text-lg font-bold text-purple-800 mt-2'>
              PKR{' '}
              {((totalPlotAmount || 0) / (installments?.length || 1)).toLocaleString()}
            </p>
          </div>
        </div>


        {/* Tabs */}
        <div className='bg-white px-6 py-4 border-b border-slate-100'>
          <div className='flex justify-between items-center'>
            <div className='flex space-x-2'>
              <button
                onClick={() => {
                  setActiveTab('completed')
                  setCurrentPage(1)
                }}
                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all duration-300 ${activeTab === 'completed'
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
              >
                Completed
              </button>
              <button
                onClick={() => {
                  setActiveTab('pending')
                  setCurrentPage(1)
                }}
                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all duration-300 ${activeTab === 'pending'
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
              >
                Remaining
              </button>
            </div>

            <button
              onClick={handlePrint}
              className='px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 shadow-md text-sm font-bold'
            >
              <FileText className='w-4 h-4' strokeWidth={1.5} />
              <span>Print Summary</span>
            </button>
          </div>
        </div>
      </div>

      {/* Scrollable Content */}
      <div className='flex-grow overflow-auto custom-scrollbar bg-white'>
        <div className='min-w-full'>
          <table className='w-full'>
            <thead className='sticky top-0 bg-slate-50 shadow-sm z-10'>
              <tr>
                <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>
                  No.
                </th>
                <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>
                  Amount
                </th>
                <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>
                  Date
                </th>
                <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {getCurrentInstallments().map(inst => (
                <tr
                  key={inst.installment_number}
                  className='border-b border-gray-100 hover:bg-blue-50/50 transition-colors'
                >
                  <td className='px-6 py-4 text-gray-800'>
                    {inst.installment_number}
                  </td>
                  <td className='px-6 py-4 text-gray-800'>
                    PKR{' '}
                    {(activeTab === 'completed'
                      ? (inst.paid_amount || 0)
                      : Math.max(0, Number(inst.remaining_amount || 0))
                    ).toLocaleString()}
                  </td>
                  <td className='px-6 py-4 text-gray-800'>
                    {new Date(
                      activeTab === 'completed'
                        ? inst.payment_date
                        : inst.due_date
                    ).toLocaleDateString('en-GB')}
                  </td>
                  <td className='px-6 py-4'>
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium ${inst.status === 'Completed'
                        ? 'bg-green-100 text-green-700'
                        : inst.status === 'Pending'
                          ? 'bg-yellow-100 text-yellow-700'
                          : 'bg-red-100 text-red-700'
                        }`}
                    >
                      {inst.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Fixed Footer */}
      <div className='flex-none bg-white border-t border-gray-200'>
        <div className='flex justify-between items-center p-4'>
          <p className='text-sm text-gray-600'>
            Showing page {currentPage} of {totalPages}
          </p>
          <div className='flex space-x-2'>
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className='p-2 rounded-lg disabled:opacity-50 hover:bg-blue-100 transition-colors'
            >
              <ChevronLeft className='w-5 h-5 text-blue-600' />
            </button>
            <button
              onClick={() =>
                setCurrentPage(prev => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className='p-2 rounded-lg disabled:opacity-50 hover:bg-blue-100 transition-colors'
            >
              <ChevronRight className='w-5 h-5 text-blue-600' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompletedInstallmentsPrint
